import { EPIC_BEGIN, EPIC_END } from './constants';

export var epicBegin = function epicBegin() {
  return { type: EPIC_BEGIN };
};

export var epicEnd = function epicEnd() {
  return { type: EPIC_END };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-most/es/actions.js
// module id = 867
// module chunks = 0